import { afterAnimationEnd, debounce } from './utils.js';

//+ Updating cart
document.addEventListener('cart:updated', (e) => {
    const itemCount = e.detail.cart.item_count;

    if (itemCount) {
        updateCartLength(itemCount);
    } else {
        fetch('/cart.js')
            .then((res) => res.json())
            .then((data) => updateCartLength(data.item_count));
    }
});

function updateCartLength(amount) {
    document.querySelectorAll('[data-cart-length]').forEach((el) => (el.textContent = amount));
}

//+ Lazy Resize

/**
 * Dispatches a custom 'lazy:resize' event.
 */
function dispatchLazyResizeEvent(e) {
    const event = new Event('lazy:resize', e);
    window.dispatchEvent(event);
}
/**
 * Dispatches a custom 'breakpoint:crossed' event when the window width crosses 850px.
 */
function dispatchBreakpointCrossedEvent() {
    const width = window.innerWidth;
    const isMobile = width <= 850;

    // Check if the breakpoint has been crossed
    if (window.isMobile !== isMobile) {
        window.isMobile = isMobile;
        const event = new CustomEvent('breakpoint:crossed', {
            detail: { width: width, isMobile: isMobile }
        });
        window.dispatchEvent(event);
    }
}

// Add a debounced event listener for the 'resize' event
window.addEventListener(
    'resize',
    debounce(() => {
        dispatchLazyResizeEvent();
        dispatchBreakpointCrossedEvent();
    }, 300)
);

dispatchBreakpointCrossedEvent();

//+ Script Loaded Event

function handleScriptLoad(event) {
    const scriptSrc = event.target.src;
    const url = new URL(scriptSrc);
    const scriptName = url.pathname.substring(url.pathname.lastIndexOf('/') + 1);
    document.dispatchEvent(
        new CustomEvent('script:loaded', { detail: { src: scriptSrc, name: scriptName } })
    );
    document.dispatchEvent(
        new CustomEvent(`script:loaded:${scriptName}`, { detail: { src: scriptSrc, name: scriptName } })
    );
}

document.querySelectorAll('script').forEach((script) => {
    script.addEventListener('load', handleScriptLoad);
});

/* Lazy Init Script */

/**
 * Adds an observer to initialise a script when an element is scrolled into view.
 * @param {Element} element - Element to observe.
 * @param {Function} callback - Function to call when element is scrolled into view.
 * @param {number} [threshold=500] - Distance from viewport (in pixels) to trigger init.
 */
export function initLazyScript(element, callback, threshold = 500) {
    if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        if (typeof callback === 'function') {
                            callback();
                            observer.unobserve(entry.target);
                        }
                    }
                });
            },
            { rootMargin: `0px 0px ${threshold}px 0px` }
        );

        io.observe(element);
    } else {
        callback();
    }
}

//+  Only open one details at a time

document.addEventListener('DOMContentLoaded', initMaxOpenDetails);

function initMaxOpenDetails() {
    const containers = document.querySelectorAll('[data-max-open-one]');

    containers.forEach((container) => {
        const detailsElements = container.querySelectorAll('details');

        detailsElements.forEach((details) => {
            details.addEventListener('toggle', () => {
                if (details.open) {
                    detailsElements.forEach((otherDetails) => {
                        if (otherDetails !== details) {
                            otherDetails.open = false;
                        }
                    });
                }
            });
        });
    });
}

//+ Reset Form Button

export function initResetFormButtons() {
    document
        .querySelectorAll('[data-reset-form]')
        .forEach((el) => el.addEventListener('click', handleResetClick));

    /**
     *
     * @param {Event} evt - The click event object.
     */
    function handleResetClick(evt) {
        const button = evt.currentTarget;

        const formId = button.dataset.resetForm;
        let form = document.getElementById(formId);
        if (!form) {
            form = button.closest('form');
        }

        if (form) {
            resetForm(form);
        }
    }

    function resetForm(form) {
        const formElements = form.querySelectorAll('input, select, textarea');
        formElements.forEach((element) => {
            if (element.type === 'checkbox' || element.type === 'radio') {
                element.checked = false;
            } else if (element.type === 'range') {
                element.value = 0;
            } else {
                element.value = '';
            }

            element.dispatchEvent(new Event('change', { bubbles: true }));
            element.dispatchEvent(new Event('input', { bubbles: true }));
        });
    }
}

document.addEventListener('DOMContentLoaded', initResetFormButtons);

//+  Close details on click outside

function initCloseOnUnfocus() {
    const details = document.querySelectorAll('[data-unfocus-close]');

    details.forEach((details) => {
        details.setAttribute('tabindex', '-1');

        details.addEventListener('focusout', (evt) => {
            setTimeout(() => {
                if (!details.contains(document.activeElement)) {
                    details.open = false;
                }
            }, 100);
        });
    });
}

document.addEventListener('DOMContentLoaded', initCloseOnUnfocus);

//+ Smooth Open Details

document.addEventListener('DOMContentLoaded', initSmoothOpenDetails);

function initSmoothOpenDetails() {
    document.querySelectorAll('details.smooth-open').forEach(function (details) {
        const height = details.getBoundingClientRect().height;

        details.style.maxHeight = height + 'px';

        details.addEventListener('click', (evt) => {
            if (details.open) {
                evt.preventDefault();

                requestAnimationFrame(() => {
                    details.style.maxHeight = height + 'px';
                });

                afterAnimationEnd(details, () => {
                    console.log('closing it');
                    details.open = false;
                });
            } else {
                details.style.maxHeight = '9999px';
            }
        });
    });
}
